<style scoped>
.addMargin {
  margin-top: 10px;
}
.grayOut {
  /* background: #f2f2f2; */
  color: rgb(170, 170, 170);
}
.ivu-avatar-large.ivu-avatar-icon {
  border-radius: 0;
}

.resource-container {
  display: flex;
  padding: 10px;
  background: #fff;
  border-bottom: 1px solid #eee;
  align-items: center;
  cursor: pointer;
}

.resource-avatar {
  margin-right: 10px;
}

.resource-body {
  overflow: hidden;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.resource-content > h3 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.resource-content {
  overflow: hidden;
  margin-right: 30px;
}
</style>

<template>
  <app-layout class="resource-menu-page-template">
    <Row type="flex" justify="center">
      <!-- <i-col :span="24" v-for="(item,k) in menuList" :key="k" :class="(item.break) ? 'addMargin': ''" >
        <Card :class="(item.isGray) ? 'grayOut': ''" shadow :style="{borderRadius: '0', borderTop: '0px solid #F2F2F2', cursor: 'pointer', paddingLeft: '15px', paddingRight: '15px', paddingBottom: '8px', paddingTop: '8px'}" :padding="0">
          <div @click="viewPage(item.link)"> -->
            <!-- <Icon v-if="!item.noArrow && isMobile" type="chevron-right" style="float:right;margin-top:3px"></Icon> -->
            <!-- <Icon :type="item.icon" style="vertical-align: middle;" size="25"></Icon> &nbsp; {{item.label}} -->
            <!-- <Avatar :src="item.icon" class="avatar-icon" style="background:#333;vertical-align:middle;"></Avatar> &nbsp; {{item.label}}
          </div>
        </Card>
      </i-col> -->
      <i-col :span="24">
        <PlanFeaturedActivity ltype="extra"></PlanFeaturedActivity>
      </i-col>

      <i-col :span="24" v-for="(item, i) in extras" :key="i">
        <div class="resource-container" v-on:click="redirectExtras(item)">
          <div class="resource-avatar">
            <Avatar :src="menuPreviewImage(item)"  shape="square" size="large"></Avatar>
          </div>
          <div class="resource-body">
            <div class="resource-content">
                <h3>{{item.title}}</h3>
            </div>
          </div>
        </div>
      </i-col>
    </Row>
  </app-layout>
</template>

<script>
import VueCookie from 'vue-cookie'
import _ from 'lodash';
import Utils from '@/utils.js'
import PlanFeaturedActivity from '@/components/GroupFeatureActivity'

export default {
  name: 'ResourceMenuComponent',
  components: {
    PlanFeaturedActivity
  },
  computed: {
    userInfo: {
      get() { return this.$store.state.user.info}
    },
    isMobile: {
      get() {
        return this.$store.state.isMobile;
      }
    },
    extras: {
      get() {
        return _.orderBy(this.$store.state.resource.resources.extras.pages, 'order')
      }
    }
  },
  mounted() {
    this.$store.dispatch('resource/getExtrass');
    this.$store.dispatch('feature/getExtraFeaturedActivity', {id: Cons[0].GROUP_ID.extras})
  },
  data () {
    return {
      menuList: [
        // { icon: require('@/assets/resources/Advocacies.png'), label: 'Advocacies', link: '/advocacies'},
        // { icon: require('@/assets/resources/Organizations.png'), label: 'Organizations', link: '/organization' },
        // { icon: require('@/assets/resources/Special-Projects.png'), label: 'Special Projects', link: '/resources/list?type=special_project' },
        // { icon: require('@/assets/resources/Events.png'), label: 'Events', link: '/events', isGray: 1 },
        // { icon: require('@/assets/resources/Videos.png'), label: 'Videos', link: '/videos' },
        // { icon: require('@/assets/resources/FAQ.png'), label: 'FAQ', link: '/faq', isGray: 1 },
        // { icon: 'ios-help', label: 'Marawi Rehabilitation', link: '/resources/list?type=marawi_rehabilitation' },
        // { icon: 'ios-help', label: 'Groups', link: '/resources/list?type=groups' },
        // { icon: 'ios-help', label: 'Artwork', link: '/artwork', isGray: 1 },
        // { icon: 'ios-help', label: 'Recommended', link: '/coming-soon', isGray: 1 },
      ]
    }
  },
  methods: {
    menuPreviewImage (act) {
      if( act.cover_photo ) {
        return Utils.getDisplayImage('activity', act, 'medium')
      } else {
        if(act.type === 'add_ons') {
          if(!act.cover_photo) {
            if( act.data.add_on_slug === 'events')
              return require('@/assets/resources/Events.png')
            if( act.data.add_on_slug === 'videos')
              return require('@/assets/resources/Videos.png')
            if( act.data.add_on_slug === 'faq')
              return require('@/assets/resources/FAQ.png')
          } else {
            return Utils.getDisplayImage('activity', act, 'medium')
          }
        }
      }
    },
    viewPage (v) {
      this.$router.push({ path: v })
    },
    redirectExtras (item) {
      if(item.type == 'sub_menu') {
        console.log(item.title)
        this.$router.push({ path: '/submenu/' + item.data.group_id, meta: { title: item.title } })
        return false;
      }

      if(item.type == 'group_page') {
        this.$router.push({ path: '/resources/' + item.data.careplan_id + '?tab=posts' })
        return false;
      }

      if(item.type == 'group_page_type') {
        this.$router.push({ path: '/group-type/' + item.data.group_type })
        return false;
      }

      if(item.type == 'module_page') {
        this.$router.push({ path: '/module/' + item.data.module_id + '?tab=course' })
        return false;
      }

      if(item.type == 'element_page') {
        this.$router.push({ path: '/feed/' + item.data.element_id})
        return false;
      }

      if(item.type == 'add_ons') {
        console.log('test')
        BroadcastEvent.$emit("ADDONMENU", item);
        // if( item.data.add_on_slug === 'events')
        //   this.$router.push({ path: '/events' })
        // if( item.data.add_on_slug === 'videos')
        //   this.$router.push({ path: '/videos' })
        // if( item.data.add_on_slug === 'faq')
        //   this.$router.push({ path: '/faq' })
        return false;
      }

      if(item.type != 'hybrid') {
        this.$router.push({ path: '/feed/' + item.id })
      } else {
        this.$router.push({ path: '/extras/' + item.id })
      }
    }
  },
}
</script>
